import {
	TFileId,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
	ICreateCategory,
	IItemForGetShortInfo,
} from 'types';
import { TVisibleForm, TTCategoryType, TTypeOfModalWindow } from './createCategoryContext';

export enum CreateCategoryActionTypes {
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FILE_ID = 'SET_FILE_ID',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	CHANGE_NAME_OF_CATEGORY = 'CHANGE_NAME_OF_CATEGORY',
	SET_CATEGORY_TYPE = 'SET_CATEGORY_TYPE',
	TOGGLE_IS_RESTRICTED = 'TOGGLE_IS_RESTRICTED',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_FETCHED_TRANSLATIONS = 'SET_FETCHED_TRANSLATIONS',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeVisibleForm {
	type: CreateCategoryActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TVisibleForm;
	};
}

interface ISetFileId {
	type: CreateCategoryActionTypes.SET_FILE_ID;
	payload: {
		fileId: TFileId;
	};
}

interface ISetFetchedCustomers {
	type: CreateCategoryActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		customers: IItemForGetShortInfo[];
	};
}

interface ISetIDCustomer {
	type: CreateCategoryActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: Nullable<string>;
	};
}

interface ISetFetchedRestaurants {
	type: CreateCategoryActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		restaurants: IItemForGetShortInfo[];
	};
}

interface ISetIDsRestaurant {
	type: CreateCategoryActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: string[];
	};
}

interface IChangeNameOfCategory {
	type: CreateCategoryActionTypes.CHANGE_NAME_OF_CATEGORY;
	payload: {
		nameOfCategory: string;
	};
}

interface ISetCategoryType {
	type: CreateCategoryActionTypes.SET_CATEGORY_TYPE;
	payload: {
		categoryType: TTCategoryType;
	};
}

interface IToggleIsRestricted {
	type: CreateCategoryActionTypes.TOGGLE_IS_RESTRICTED;
}

interface IChangeActivationSchedule {
	type: CreateCategoryActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: string;
	};
}

interface IChangeDeactivationSchedule {
	type: CreateCategoryActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: string;
	};
}

interface ISetFetchedTranslation {
	type: CreateCategoryActionTypes.SET_FETCHED_TRANSLATIONS;
	payload: {
		translations: IMenuTranslation[];
		defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	};
}

interface ISetTranslationTab {
	type: CreateCategoryActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: TLanguageIDs | null;
	};
}

interface IChangeTranslation {
	type: CreateCategoryActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IMenuTranslation[];
	};
}

interface ISetDataForSubmit {
	type: CreateCategoryActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateCategory | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IResetSelectedControls {
	type: CreateCategoryActionTypes.RESET_FIELDS;
}

export type TCreateCategoryAction =
	| IChangeVisibleForm
	| ISetFileId
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetFetchedRestaurants
	| ISetIDsRestaurant
	| IResetSelectedControls
	| IChangeNameOfCategory
	| ISetCategoryType
	| IToggleIsRestricted
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetFetchedTranslation
	| ISetTranslationTab
	| IChangeTranslation
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
